// UMD-specific entry point that exports constructor function directly
// This avoids webpack getter patterns that fail in Salesforce LockerService

import { OptaveJavaScriptSDK } from './main.js';
// Import crypto polyfill for side effects (sets up global crypto for UUID generation)
import '../platform/browser/crypto-polyfill.js';

// Expose the constructor on the browser global, preferring `window`.
// Salesforce Lightning loads this UMD bundle as a static resource and reads
// `window.OptaveJavaScriptSDK`; under Lightning Locker the component's global is
// `window` (a SecureWindow), which is NOT guaranteed to be the same object as
// `globalThis`. We assign to both `window` (browser/Salesforce) and `globalThis`
// (Node, and web workers where globalThis === self), which together cover every
// target. Idempotent and defensive.
if (typeof window !== 'undefined' && !window.OptaveJavaScriptSDK) {
  try {
    window.OptaveJavaScriptSDK = OptaveJavaScriptSDK;
  } catch { /* noop – defensive */ }
}
if (typeof globalThis !== 'undefined' && !globalThis.OptaveJavaScriptSDK) {
  try {
    globalThis.OptaveJavaScriptSDK = OptaveJavaScriptSDK;
  } catch { /* noop – defensive */ }
}

// Export default for webpack UMD library.export: 'default'
// Consumers using script tags get globalThis.OptaveJavaScriptSDK; module/bundler
// users import the default export.
export default OptaveJavaScriptSDK;
